<ng-container *ngIf="open">
  <div class="fixed inset-0 z-[8000] bg-black/50 backdrop-blur-sm" (click)="onClose()"></div>

  <div
    class="fixed top-0 right-0 z-[8001] h-dvh w-full max-w-[520px] bg-white dark:bg-surface-1 shadow-2xl flex flex-col"
    (click)="$event.stopPropagation()"
    id="auth_form_panel"
  >
    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-5 border-b border-slate-100 dark:border-slate-700/60 shrink-0">
      <div class="flex items-center gap-3">
        <div class="w-8 h-8 rounded-lg bg-gradient-to-br from-purple-500 to-indigo-600 flex items-center justify-center shadow-sm">
          <svg class="w-4 h-4 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          </svg>
        </div>
        <div>
          <h2 class="text-sm font-semibold text-slate-800 dark:text-white">
            {{ mode === 'edit' ? 'Edit Access Key' : 'New Access Key' }}
          </h2>
          <p class="text-xs text-slate-400 dark:text-slate-500 mt-0.5">
            {{ mode === 'create' ? 'Add a universal credential the function tools authenticate with' : 'Update this access key' }}
          </p>
        </div>
      </div>
      <button
        (click)="onClose()"
        class="flex items-center justify-center w-8 h-8 rounded-lg text-slate-400 hover:text-slate-700 dark:hover:text-white hover:bg-slate-100 dark:hover:bg-slate-700/60 transition-colors"
        id="auth_form_close_btn"
      >
        <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="flex-1 overflow-y-auto px-6 py-5 space-y-5">
      <div
        *ngIf="errorMsg()"
        class="p-3 rounded-xl bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800/50 text-xs text-red-700 dark:text-red-400"
        id="auth_form_error"
      >
        {{ errorMsg() }}
      </div>

      <!-- name -->
      <div>
        <label class="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">
          Name <span class="text-red-500">*</span>
        </label>
        <input
          type="text"
          [(ngModel)]="form.name"
          placeholder="crm-booking-api"
          class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/50
                 text-sm text-slate-800 dark:text-white placeholder:text-slate-300 dark:placeholder:text-slate-600
                 focus:outline-none focus:ring-2 focus:ring-purple-500/40"
          id="auth_form_name"
        />
        <p class="text-[10px] text-slate-400 mt-1">
          A short, unique label the live-call tools reference. Unique across the catalog.
        </p>
      </div>

      <!-- base_url -->
      <div>
        <label class="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">
          Base URL <span class="text-red-500">*</span>
        </label>
        <input
          type="text"
          [(ngModel)]="form.base_url"
          placeholder="https://api.example.com"
          class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/50
                 text-sm text-slate-800 dark:text-white placeholder:text-slate-300 dark:placeholder:text-slate-600
                 focus:outline-none focus:ring-2 focus:ring-purple-500/40 font-mono"
          id="auth_form_base_url"
        />
      </div>

      <!-- auth_type -->
      <div>
        <label class="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">
          Auth Type <span class="text-red-500">*</span>
        </label>
        <select
          [(ngModel)]="form.auth_type"
          class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/50
                 text-sm text-slate-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-purple-500/40"
          id="auth_form_auth_type"
        >
          <option *ngFor="let opt of authTypeOptions" [ngValue]="opt.value">{{ opt.label }}</option>
        </select>
      </div>

      <!-- token -->
      <div>
        <label class="block text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1.5">
          Token
        </label>
        <input
          type="password"
          autocomplete="new-password"
          [(ngModel)]="form.token"
          [disabled]="mode === 'edit' && clearToken"
          placeholder="Paste the secret to store"
          class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/50
                 text-sm text-slate-800 dark:text-white placeholder:text-slate-300 dark:placeholder:text-slate-600
                 focus:outline-none focus:ring-2 focus:ring-purple-500/40 disabled:opacity-50"
          id="auth_form_token"
        />
        <p *ngIf="mode === 'edit'" class="text-[10px] text-slate-400 mt-1">
          Leave blank to keep the current token{{ tokenSuffix ? ' (•••• ' + tokenSuffix + ')' : '' }}
        </p>
      </div>

      <!-- clear_token (edit only) -->
      <label
        *ngIf="mode === 'edit'"
        class="flex items-start gap-3 p-3 rounded-xl border border-slate-200 dark:border-slate-700 cursor-pointer
               hover:bg-slate-50 dark:hover:bg-slate-800/40 transition-colors"
      >
        <input
          type="checkbox"
          [(ngModel)]="clearToken"
          class="mt-0.5 w-4 h-4 rounded accent-red-500"
          id="auth_form_clear_token"
        />
        <span>
          <span class="block text-xs font-semibold text-slate-700 dark:text-slate-200">Clear token</span>
          <span class="block text-[10px] text-slate-400 mt-0.5">
            Removes the stored secret entirely. Overrides anything typed above.
          </span>
        </span>
      </label>

      <!-- is_active -->
      <label
        class="flex items-start gap-3 p-3 rounded-xl border border-slate-200 dark:border-slate-700 cursor-pointer
               hover:bg-slate-50 dark:hover:bg-slate-800/40 transition-colors"
      >
        <input
          type="checkbox"
          [(ngModel)]="form.is_active"
          class="mt-0.5 w-4 h-4 rounded accent-emerald-600"
          id="auth_form_is_active"
        />
        <span>
          <span class="block text-xs font-semibold text-slate-700 dark:text-slate-200">Active</span>
          <span class="block text-[10px] text-slate-400 mt-0.5">
            Inactive entries stay listed here but cannot be picked by tools.
          </span>
        </span>
      </label>
    </div>

    <!-- Footer -->
    <div class="flex gap-3 px-6 py-4 border-t border-slate-100 dark:border-slate-700/60 shrink-0">
      <button
        (click)="onClose()"
        class="flex-1 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-medium
               text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors"
        id="auth_form_cancel_btn"
      >
        Cancel
      </button>
      <button
        (click)="onSubmit()"
        [disabled]="saving()"
        class="flex-1 py-2.5 rounded-xl text-sm font-semibold text-white bg-gradient-to-r from-purple-500 to-indigo-600
               hover:from-purple-600 hover:to-indigo-700 disabled:opacity-60 transition-all active:scale-95"
        id="auth_form_submit_btn"
      >
        <span *ngIf="!saving()">{{ mode === 'create' ? 'Add Access Key' : 'Save Changes' }}</span>
        <span *ngIf="saving()" class="flex items-center justify-center gap-2">
          <span class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
          Saving…
        </span>
      </button>
    </div>
  </div>
</ng-container>
